import { payflowTrackActionsService } from '@ctct/domain-layer';

import type { Controller, Listeners, TEventSource } from '../helpers';
import { controllerHelpers } from '../helpers';
import {
  contactsTierSelectEventBus,
  emailPlansEventBus,
  type EmailPlanChangedPayload,
  planComparisonTableEventBus,
  prepaySelectEventBus,
} from '../managers';

export class ValueFocusedMWebTrackingController implements Controller {
  public listeners: Listeners;

  constructor() {
    const eventConnections = [
      contactsTierSelectEventBus.bindTo('contactTierChanged', this.onContactTierChanged),
      prepaySelectEventBus.bindTo('prepayChanged', this.onPrepayChanged),
      emailPlansEventBus.bindTo('emailPlanChanged', this.onEmailPlanChanged),
      planComparisonTableEventBus.bindTo('viewAllFeaturesExpanded', this.onViewAllFeaturesExpanded),
      planComparisonTableEventBus.bindTo('viewAllFeaturesCollapsed', this.onViewAllFeaturesCollapsed),
      planComparisonTableEventBus.bindTo('scrollDepthReached', this.onScrollDepthReached),
    ];

    this.listeners = controllerHelpers.createListeners(eventConnections);
  }

  private onContactTierChanged = (contactTier: string, { source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.contactTierSelected(contactTier);
  };

  private onPrepayChanged = (prepayValue: string, { source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.prepayToggled(prepayValue);
  };

  private onEmailPlanChanged = ({ planName }: EmailPlanChangedPayload, { source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.planTileCtaClicked(planName);
  };

  private onViewAllFeaturesExpanded = ({ source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.viewAllFeaturesExpanded();
  };

  private onViewAllFeaturesCollapsed = ({ source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.viewAllFeaturesCollapsed();
  };

  private onScrollDepthReached = (featureName: string, { source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    payflowTrackActionsService.comparisonTableScrollDepth(featureName);
  };
}
